export default __webpack_public_path__ + "static/media/opeyemi.bd9526f6.png";